import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-slide-in-panel',
  templateUrl: './slide-in-panel.component.html',
  styleUrls: ['./slide-in-panel.component.scss']
})
export class SlideInPanelComponent {

  @Input() title = '';
  @Input() className = '';
  @Input() isChildPanel = false; // If true, the panel will not show an overlay as it will have already been rendered by the parent

  isVisible = false;

  show() {
    this.isVisible = true;
  }

  hide() {
    this.isVisible = false;
  }
}